import * as React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AppShell, createStyles } from '@mantine/core';
import routes from './index';
import SideMenu from '../lib/side-menu';
import axios from "axios";
import { IResponse } from "../types/api";
import useStore from "../store";
import { IStats } from "../store/types";
import { useSongStats } from "../hooks";

const useStyles = createStyles(() => {
    return {
        main: {
            height: '100vh',
            overflow: 'hidden'
        },
    }
})

const ProtectedRoutes = () => {

    const { classes } = useStyles();

    const location = useLocation();

    const fetchData = useSongStats();

    React.useEffect(() => {
        void fetchData()
    }, []);

    if (location.pathname === '/') {
        // TODO: Make it redirect to first possible side menu item
        return <Navigate replace to={'/categories'}/>
    }

    const getRoutes = () => {
        const array: JSX.Element[] = [];
        for (const route of routes) {
            if (route.element) {
                const RouteElement = route.element;
                array.push(
                    <Route key={route.path} path={route.path} element={<RouteElement />} />
                )
            }
        }
        return array;
    }

    return (
        <AppShell
            navbarOffsetBreakpoint='sm'
            asideOffsetBreakpoint='sm'
            navbar={<SideMenu/>}
            classNames={{ main: classes.main }}
        >
            <Routes>
                {getRoutes()}
            </Routes>
        </AppShell>
    )
};

export default ProtectedRoutes;
